import { hiprint } from 'vue-plugin-hiprint';
import { previewSamplesData, previewDeviceData, providerDeviceAdjustData, previewCertificateData } from './testData';

// 样品标签
export const providerSample = function () {
  var addElementTypes = function (context) {
    context.removePrintElementTypes('providerSample');
    context.addPrintElementTypes('providerSample', [
      new hiprint.PrintElementTypeGroup('基础文本', [
        {
          tid: 'providerSample.text0',
          title: '待检',
          type: 'text',
          options: {
            width: 30,
            height: 10,
            fontSize: 6,
            hideTitle: true
          }
        },
        {
          tid: 'providerSample.text1',
          title: '在检',
          type: 'text',
          options: {
            width: 30,
            height: 10,
            fontSize: 6,
            hideTitle: true
          }
        },
        {
          tid: 'providerSample.text2',
          title: '已检',
          type: 'text',
          options: {
            width: 30,
            height: 10,
            fontSize: 6,
            hideTitle: true
          }
        },
        {
          tid: 'providerSample.text3',
          title: '留样',
          type: 'text',
          options: {
            width: 30,
            height: 10,
            fontSize: 6,
            hideTitle: true
          }
        },
        {
          tid: 'providerSample.customText',
          title: '自定义文本',
          type: 'text',
          options: {
            fontSize: 6,
            hideTitle: true
          }
        }
      ]),
      new hiprint.PrintElementTypeGroup('样品业务元素', [
        {
          tid: 'providerSample.itemNo',
          title: '样品编号',
          type: 'text',
          options: {
            width: 112,
            fontSize: 6,
            field: 'itemNo',
            testData: 'SKJCH-2100-1000-01'
          }
        }
      ]),
      new hiprint.PrintElementTypeGroup('辅助', [
        {
          tid: 'providerSample.hline',
          title: '横线',
          type: 'hline',
          options: {
            height: 5
          }
        },
        {
          tid: 'providerSample.icon1',
          title: '多选框',
          type: 'image',
          options: {
            width: 7,
            height: 7,
            src: require('../../../../assets/icon/icon-chcek-n.png')
          }
        },
        {
          tid: 'providerSample.icon2',
          title: '多选框-选中',
          type: 'image',
          options: {
            width: 7,
            height: 7,
            src: require('../../../../assets/icon/icon-chcek-a.png')
          }
        }
      ])
    ]);
  };
  return {
    addElementTypes: addElementTypes
  };
};

// 设备标签
export const providerDevice = function () {
  var addElementTypes = function (context) {
    context.removePrintElementTypes('providerDevice');
    context.addPrintElementTypes('providerDevice', [
      new hiprint.PrintElementTypeGroup('基础文本', [
        {
          tid: 'providerDevice.text0',
          title: '安徽宏源顺安检测技术有限公司',
          type: 'text',
          options: {
            fontSize: 6.75,
            textAlign: 'center',
            width: 100
          }
        },
        {
          tid: 'providerDevice.text1',
          title: 'SHUNKAIJIANCE',
          type: 'text',
          options: {
            fontSize: 6.75,
            textAlign: 'center',
            width: 90
          }
        }
      ]),
      new hiprint.PrintElementTypeGroup('样品业务元素', [
        {
          tid: 'providerDevice.t1',
          title: '管理编号/出厂编号',
          type: 'text',
          options: {
            width: 90,
            fontSize: 5,
            hideTitle: true,
            field: 't1',
            testData: '(管理编号/出厂编号)'
          }
        },
        {
          tid: 'providerDevice.t2',
          title: '设备名称',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't2',
            testData: '(设备名称)'
          }
        },
        {
          tid: 'providerDevice.t3',
          title: '型号',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't3',
            testData: '(型号)'
          }
        },
        {
          tid: 'providerDevice.t4',
          title: '校准检定单位',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't4',
            testData: '(校准检定单位)'
          }
        },
        {
          tid: 'providerDevice.t5',
          title: '使用期限',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't5',
            testData: '(使用期限)'
          }
        },
        {
          tid: 'providerDevice.t6',
          title: '固定资产编号',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't6',
            testData: '(固定资产编号)'
          }
        },
        {
          tid: 'providerDevice.deviceUrl',
          title: '二维码',
          options: {
            fontSize: 6,
            field: 'deviceUrl',
            textType: 'qrcode',
            hideTitle: true,
            height: 40,
            width: 40,
            qrcodeType: 'qrcode',
            testData: '123456'
          }
        }
      ])
    ]);
  };
  return {
    addElementTypes: addElementTypes
  };
};

// 设备校准标签
export const providerDeviceAdjust = function () {
  var addElementTypes = function (context) {
    context.removePrintElementTypes('providerDeviceAdjust');
    context.addPrintElementTypes('providerDeviceAdjust', [
      new hiprint.PrintElementTypeGroup('基础文本', [
        {
          tid: 'providerDeviceAdjust.text0',
          title: '安徽宏源顺安检测技术有限公司',
          type: 'text',
          options: {
            fontSize: 6,
            hideTitle: true
          }
        }
      ])
    ]);
  };
  return {
    addElementTypes: addElementTypes
  };
};

// 合格证
export const providerCertificate = function () {
  const addElementTypes = function (context) {
    context.removePrintElementTypes('providerCertificate');
    context.addPrintElementTypes('providerCertificate', [
      new hiprint.PrintElementTypeGroup('基础文本', [
        {
          tid: 'providerCertificate.companyName',
          title: '安徽宏源顺安检测技术有限公司',
          custom: true,
          type: 'text',
          options: {
            fontSize: 8.25,
            textAlign: 'center',
            width: 120
          }
        },
        {
          tid: 'providerCertificate.qualified',
          title: '合格证',
          custom: true,
          type: 'text',
          options: {
            fontSize: 8.25,
            width: 120,
            textAlign: 'center'
          }
        },
        {
          tid: 'providerCertificate.unqualified',
          title: '不合格证',
          custom: true,
          type: 'text',
          options: {
            fontSize: 8.25,
            width: 120,
            textAlign: 'center'
          }
        },
        {
          tid: 'providerCertificate.customText',
          title: '自定义文本',
          type: 'text',
          options: {
            fontSize: 6,
            hideTitle: true
          }
        }
      ]),
      new hiprint.PrintElementTypeGroup('样品业务元素', [
        {
          tid: 'providerCertificate.clientname',
          title: '送检单位',
          type: 'text',
          options: {
            height: 20,
            width: 160,
            fontSize: 6,
            field: 'clientname',
            testData: '测试长文本测试长文本测试长文本测试长文本测试长文本公司'
          }
        },
        {
          tid: 'providerCertificate.itemName',
          title: '试样名称',
          type: 'text',
          options: {
            width: 112,
            fontSize: 6,
            field: 'itemName',
            testData: '测试试样名称'
          }
        },
        {
          tid: 'providerCertificate.model',
          title: '规格型号',
          type: 'text',
          options: {
            width: 52,
            fontSize: 6,
            field: 'model',
            testData: '0.1KV'
          }
        },
        {
          tid: 'providerCertificate.itemNo',
          title: '试样编号',
          type: 'text',
          options: {
            width: 112,
            fontSize: 6,
            field: 'itemNo',
            testData: 'SKJC21000101-01'
          }
        },
        {
          tid: 'providerCertificate.itemInterNo',
          title: '试样自编号',
          type: 'text',
          options: {
            width: 112,
            fontSize: 6,
            field: 'itemInterNo',
            testData: '/'
          }
        },
        {
          tid: 'providerCertificate.curTestDate',
          title: '本次检验日期',
          type: 'text',
          options: {
            width: 112,
            fontSize: 6,
            field: 'curTestDate',
            testData: '2050-01-01'
          }
        },
        {
          tid: 'providerCertificate.nextTestDate',
          title: '下次检验日期',
          type: 'text',
          options: {
            width: 112,
            fontSize: 6,
            field: 'nextTestDate',
            testData: '2100-01-01'
          }
        },
        {
          tid: 'providerCertificate.otherMembers',
          title: '检验人员',
          type: 'text',
          options: {
            width: 112,
            fontSize: 6,
            field: 'otherMembers',
            testData: '张三 李四'
          }
        },
        {
          tid: 'providerCertificate.pdfUrl',
          title: '二维码',
          options: {
            fontSize: 6,
            field: 'pdfUrl',
            textType: 'qrcode',
            hideTitle: true,
            height: 45,
            width: 45,
            title: '二维码',
            qrcodeType: 'qrcode',
            testData: '123456'
          }
        }
      ]),
      new hiprint.PrintElementTypeGroup('辅助', [
        {
          tid: 'providerCertificate.hline',
          title: '横线',
          type: 'hline',
          options: {
            height: 5
          }
        },
        {
          tid: 'providerCertificate.image',
          title: '检测专用章',
          type: 'image',
          options: {
            width: 100,
            height: 100,
            src: 'https://skjc.dunchong.cc/skjc/uploadPath/model/seal.png'
          }
        }
      ])
    ]);
  };
  return {
    addElementTypes: addElementTypes
  };
};

export const providers = [providerSample(), providerDevice(), providerDeviceAdjust(), providerCertificate()];
export const providerList = [
  {
    name: '样品',
    type: 0,
    value: 'providerSample',
    previewData: previewSamplesData,
    width: 45,
    height: 10
  },
  {
    name: '设备',
    type: 1,
    value: 'providerDevice',
    previewData: previewDeviceData,
    width: 80,
    height: 30
  },
  {
    name: '合格证',
    type: 2,
    value: 'providerCertificate',
    previewData: previewCertificateData,
    width: 49,
    height: 30
  }
];
